var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.sectionClass},[_c('h1',[_vm._v("Program Kami")])])
}
var staticRenderFns = []

export { render, staticRenderFns }